import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { Store } from "lucide-react";
import { MarketplacePage } from "@/pages/marketplace";
import { PackDetailPage } from "@/pages/marketplace-pack";

export const marketplaceRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "marketplace",
      handle: { title: "Marketplace" },
      element: React.createElement(MarketplacePage),
    },
    {
      path: "marketplace/packs/:packId",
      handle: { title: "Marketplace" },
      element: React.createElement(PackDetailPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/marketplace",
      title: "Marketplace",
      summary: "Reviewed packs, skills, and tools for your workflows.",
      end: false,
    },
  ],
};

export const marketplaceNav: FeatureNavModule = {
  marketplaceItem: {
    to: "/marketplace",
    label: "Marketplace",
    icon: Store,
    end: false,
  },
};
